var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinPaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3C6.05228 3 6.5 2.55228 6.5 2C6.5 1.44772 6.05228 1 5.5 1C4.94772 1 4.5 1.44772 4.5 2C4.5 2.55228 4.94772 3 5.5 3Z",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5Z",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49987 5C4.82818 5 5.15327 5.06466 5.45658 5.1903C5.7599 5.31594 6.0355 5.50009 6.26764 5.73223C6.49979 5.96438 6.68394 6.23998 6.80957 6.54329C6.93521 6.84661 6.99987 7.1717 6.99987 7.5V9.25C6.99974 9.66823 6.84982 10.0726 6.57728 10.3898C6.30474 10.7071 5.9276 10.9162 5.51417 10.9794C5.10074 11.0425 4.67835 10.9555 4.32352 10.7341C3.96869 10.5128 3.70488 10.1716 3.57987 9.7725C3.36654 9.08417 2.91654 8.63333 2.22987 8.42C1.83097 8.29506 1.48996 8.03145 1.26855 7.67688C1.04715 7.32232 0.959982 6.90021 1.02282 6.48694C1.08565 6.07367 1.29435 5.69655 1.61113 5.42381C1.92791 5.15107 2.33186 5.00073 2.74987 5H4.49987Z",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinPaw);
export default __webpack_public_path__ + "static/media/minPaw.eedf27ceaf4bab482d02be15619f2be7.svg";
export { ForwardRef as ReactComponent };